import React from 'react';
import { useTranslation } from 'react-i18next';

const CalendarHeader = ({ onCancel, onConfirm }) => {
    const { t } = useTranslation();

    return (
        <div className={`calendarHeader`}>
            <button className={`tertiary`} onClick={onCancel}>
                {t('cancel')}
            </button>
            <button className={`tertiary`} onClick={onConfirm}>
                {t('confirm')}
            </button>
        </div>
    );
}

export default CalendarHeader;